export default __webpack_public_path__ + "static/media/about-us.78539190.jpg";